import { render, staticRenderFns } from "./press_fit_hole.vue?vue&type=template&id=3ba15a45"
import script from "./press_fit_hole.vue?vue&type=script&lang=js"
export * from "./press_fit_hole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports